function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenldap = function SvgOpenldap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744.09 1052.4",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "openldap_svg__e",
    y2: 129.23,
    gradientUnits: "userSpaceOnUse",
    x2: 89.429,
    gradientTransform: "translate(244.83 -81.693) scale(1.9236)",
    y1: 129.23,
    x1: 80.916
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#60c"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#60c",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "openldap_svg__d",
    y2: 129.23,
    gradientUnits: "userSpaceOnUse",
    x2: 89.429,
    gradientTransform: "translate(216.56 -73.967) scale(1.9236)",
    y1: 129.23,
    x1: 80.916
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#60c"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#60c",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "openldap_svg__b",
    y2: 465.09,
    gradientUnits: "userSpaceOnUse",
    x2: 77.015,
    gradientTransform: "translate(267.18 -40.495) scale(1.9236)",
    y1: 384.81,
    x1: 8.535
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6d5744"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6d5744",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "openldap_svg__a",
    y2: 197.66,
    gradientUnits: "userSpaceOnUse",
    x2: 100.23,
    gradientTransform: "translate(267.18 -40.495) scale(1.9236)",
    y1: 163.64,
    x1: -41.915
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6d5744"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6d5744",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "openldap_svg__c",
    y2: 202.05,
    gradientUnits: "userSpaceOnUse",
    x2: 416.51,
    y1: 220.22,
    x1: 420.17
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#212121"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#212121",
      stopOpacity: 0
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416.93 357.28c-13.927 2.158-29.996 7.106-40.074 15.502 4.966 23.732 26.302-3.863 41.709 1.114 19.575-1.994 11.267-20.953-1.636-16.616zM405.02 320.44c-14.087-.44-30.791 1.47-42.241 7.87.518 24.24 26.564 1.039 40.793 8.764 19.608 1.639 14.927-18.525 1.447-16.634zM445.25 394.59c-13.87 2.5-29.812 7.842-39.68 16.484 5.548 23.602 26.199-4.51 41.724.087 19.52-2.475 10.748-21.224-2.044-16.57zM469.88 440.79c-14.484-5.122-45.334 19.408-19.277 22.574 8.32-8.557 21.103-5.338 32.541-7.27 13.791-10.401-3.588-17.608-13.264-15.303zM511.36 603.7c-19.378 6.19.023 20.385 12.165 15.99 8.792.11 17.767-.418 26.333.712 14.807-8.3-3.011-20.33-13.628-16.702h-24.87zM543.52 678c-16.558-7.786-30.682 18.894-7.972 16.243 11.17-3.076 30.464 6.068 35.019-8.248-1.659-13.088-18.785-5.98-27.047-7.995zM510.94 752.36c-23.064 11.227 20.121 24.639 19.417 29.155 5.015 8.059 5.422 11.558 9.593 13.687 18.953 4.068 9.72-18.678.806-25.048-8.268-8.393-17.81-15.759-29.816-17.794zM536.13 790.23l.06.24zM458.58 832.25c-21.038 7.37 4.813 20.578 14.908 23.685-2.962 12.592 14.925 29.912 18.094 9.738 1.794-20.17-15.98-29.587-33.002-33.423z",
    style: {
      stroke: "#816647",
      strokeWidth: 2.5007,
      fill: "#ff9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#015a01"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.98 488.01a31.122 36.497 0 1 1-1.22-64.48",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.9,
      fill: "#6c3"
    },
    transform: "translate(-39.643 -60.964) scale(1.9236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8 445.27a33.986 36.899 0 1 1 9.737 39.546",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.88405,
      fill: "#6c3"
    },
    transform: "rotate(-10.219 -127.089 1148.416) scale(1.95832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9 478.33a43.697 33.986 0 1 1 38.346 11.559",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.84894,
      fill: "#6c3"
    },
    transform: "matrix(1.86568 .99923 -1.08995 1.6453 463.551 -138.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.36 406.05a50.381 30.214 0 1 1 75.368 24.902",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.86545,
      fill: "#6c3"
    },
    transform: "matrix(1.82128 .74478 -.71166 1.9061 206.257 -166.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38 425.53a50.381 28.411 0 1 1 67.773.438",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.82037,
      fill: "#6c3"
    },
    transform: "matrix(1.99535 .47632 -.45534 2.12327 90.042 -217.313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.04 409.53a50.381 28.411 0 1 1 86.24 14.733",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.77966,
      fill: "#6c3"
    },
    transform: "matrix(2.0465 0 0 2.4093 -88.464 -261.585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39 392a46.972 26.895 0 1 1 62.784-15.176",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.806,
      fill: "#6c3"
    },
    transform: "matrix(2.1562 0 0 2.1396 -89.484 -106.989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51 375.64c4.938-9.01 1.653-17.354-7.625-24.469 6.077-17.646-8.654-60.144-35.031-91.812-1.38-1.658-3.293-2.985-5.625-4-6.188-22.424-26.148-28.54-43.875-23.594-23.792 6.64-44.719 13.087-44.719 29.25 0 8.436 5.46 16.034 14.188 21.375-.31.68-.594 1.362-.844 2.063-6.48 27.8 16.103 65.353 26.031 76.75.145.166.293.308.438.468-5.575 13.415 6.61 27.527 29.75 32.97",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.9,
      fill: "#6c3"
    },
    transform: "translate(215.33 -72.118) scale(1.9236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1 192.18a35.714 25.423 0 1 1 60.364-7.458",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.75961,
      fill: "#6c3"
    },
    transform: "rotate(-7.122 141.565 1368.623) scale(2.27916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18 192.64a35.714 26.026 0 1 1 58.892-5.404",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.75961,
      fill: "#6c3"
    },
    transform: "matrix(2.279 0 0 2.279 -132.014 -86.976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.08 200.01a35.714 26.582 0 1 1 43.239-9.101",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.75961,
      fill: "#6c3"
    },
    transform: "matrix(2.279 0 0 2.279 -127.205 -135.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.64 164.22a50.528 44.244 0 1 1 42.772 22.373",
    style: {
      stroke: "#015a01",
      strokeWidth: 0.9,
      fill: "#6c3"
    },
    transform: "rotate(-25.365 260.383 483.741) scale(1.9236)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.16 123.48c-18.445 2.416-36.231 9.639-51.157 20.739 3.67 10.439 8.552 19.439 7.764 31.245 6.17 3.425 6.974.76 8.707 8.67-5.472 1.348 12.146 3.992 16.65 3.197 12.842-6.387 1.965-24.003 5.472-35.177-1.157-12.639 4.178-18.613 12.564-28.674zm-11.662 17.072c-1.079 1.83 2.06.045 0 0zm-54.47 17.26c-14.103 14.686-23.007 34.328-24.586 54.643 5.548 6.701 10.064 14.055 23.745 12.744 12.83-.612 25.13 13.586 38.054 3.77.558-10.675-11.82-20.203-21.377-24.201-10.807-5.478-9.337-17.826-11.324-24.49-4.484-7.632-1.208-4.536-4.03-14.411-.42-2.662-.528-5.365-.481-8.056zm-39.194 77.006c-12.088 13.667-14.622 34.874-6.492 51.157-8.447 11.861-13.275 28.947-6.387 42.527 8.684 9.376 15.535 18.781 23.923 27.836 5.148 4.231 29.949 1.327 22.899-9.392 3.62-9.74 11.573-4.67 20.46-5.546-.882-6.944-13.13-21.402-3.727-21.28-5.308-.467-10.441.912-16.634-.663-2.316 1.179-11.748 3.965-16.789 7.156-2.813-4.37-9.528-9.026-14.006-13.285 6.329-6.942 12.568-11.394 18.635-22.362-1.418-11.027 1.41-23.937-4.952-34.526-4.39-7.982-9.538-16.258-16.93-21.62zm21.04 29.576c-2.579 2.068 2.648 1.222 0 0zm33.063 1.262c-7.962 8.595-13.598-.637-22.603 6.853-7.391 6.563-7.957 18.171.767 23.49 4.06 2.449 8.14 13.005 11.977 4.824 3.508-.209 6.1-.73 12.383-6.252 8.126-2.643 16.85-9.205 7.935-11.722-1.73 2.567-1.673-1.994-4.267-3.908-2.254 2.354-1.054-11.239-6.192-13.285zm9.678 15.15c-4.602 4.341 3.15 1.218 0 0zm-11.963 20.438c6.236 3.03 17.23-.028 4.42.286-1.482.204-2.946-.174-4.42-.286zm12.203.481c-.595 3.29 1.896.633 0 0zm-56.026 14.908c-.85.904 1.544.19 0 0zm43.703 3.487c-2.573 1.483 1.96-.001 0 0zm.421.12c-.561.637 1.28.297 0 0zm-13.646 20.92c-1.301.21.812 1.138 0 0zm3.907.42c-3.404 3.408 4.722.294 0 0zm-38.713 20.139c-16.799 2.284-10.957 31.496 2.805 33.354 5.64 9.286 19.757 13.694 24.547 24.655 12.72 4.112 22.56-7.895 20.44-20.018 8.73 1.284 22.706-6.826 20.378-18.335-11.926-.224-22.746-2.603-33.62 2.757-15.887 2.693-25.953-11.899-34.549-22.415zm45.025 14.968c-2.295 3.054 1.946 1.48 0 0zm-.781 1.503c-1.04-3.208-2.889 3.588 0 0zm2.645-1.503c-3.15 1.919 5.565.92 0 0zm.842 1.683c-1.517 1.519 3.67.686 0 0zm22.362 4.268c-2.081 2.173 2.8 3.946 0 0zm1.923 42.44c-1.06 2.522 4.023 2.282 0 0zm-60.835.481c-3.129 19.345 11.046 36.912 26.69 46.468-7.272 14.968 24.864 4.591 22.53-7.431-3.52-4.406-3.597-8.426-6.66-12.226 10.34.225 18.674-.723 29.335-7.574 10.545-.483-9.431-19.033-14.573-17.474-7.491 6.703-18.908 3.173-26.725 11.463-8.885-6.562-19.78-11.221-30.598-13.225zm50.616 27.232c-2.016.842 3.15 1.795 0 0zm-.781 8.236c-5.884 2.548 3.093 1.194 0 0z",
    style: {
      fill: "url(#openldap_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06 624.62c-5.876 3.042-21.757 3.705-21.12 7.535 6.706 3.036-9.727 2.31-3.046-1.524-6.055 3.63-4.387-1.105-6.973 4.509-4.344-.588-1.79-8.583-9.235-2.745-12.237 6.275-3.708 20.152 2.654 27.602 2.665 6.133 15.762-6.604 17.04 4.539 8.022-2.48 15.796-2.173 24.888-5.53 7.495-.574 12.594 10.91 15.569 5.95 7.221-1.065 4.553 7.088 9.323.252 5.226-7.084 10.894-21.606 4.856-21.06-2.713-2.06-4.296-9.432.008-2.996 4.307-2.722.144-4.5 6.852-4.492 4.604-4.489-10.706 2.535-3.846-2.481-8.94.797 7.612-4.563-4.702-3.546-8.26-1.493-26.336 1.196-28.377-1.918 6.607-4.343-4.686 1.95-3.89-4.095zm-30.177 6.853c-.382-2.596-2.783-.59 0 0zm38.413-5.35c-5.547 4.11 3.66 3.36 0 0zm-35.167 3.246c-5.571 2.012 3.462 2.668 0 0zm-4.508 2.044c-3.596 1.388 5.346 4.043 0 0zm-1.684.54c-.852 1.16.955 2.003 0 0zm69.792 10.28c-3.374 1.08 2.565 1.766 0 0zm.782 12.444 4.93 12.444c-1.211-4.275-1.661-9.11-4.93-12.444zm-65.764 27.592c-5.276 5.044-13.384 8.078-14.41 16.23-5.04 9.286.73 20.869 9.09 22.718 4.203 9.595 17.532 7.67 22.512 16.336 10.903 2.65 26.672.473 27.793-13.261 6.018-16.31 13.062 9.716 22.882 9.772 4.928-1.522 7.334-2.06 10.615 1.278 3.227-2.624 8.773-1.22 12.59-5.944 2.41-1.37 5.576-10.131-1.49-13.02-6.048-4.783-11.199-22.286-19.283-11.598-2.185-3.091-10.746-6.59-9.8-.397-5.938 4.84-10.636.017-5.796-4.921-11.975 1.757-23.053-.588-34.994-.398-5.478 1.504-14.347 1.281-6.786-4.471-3.455-4.987-10.878-6.38-12.924-12.323zm17.794 13.105c-10.605 2.308 7.362 2.827 0 0zm51.157 4.809c-1.854 2.246 4.144 1.687 0 0zm2.164 1.323c-2.217 4.01 3.012.564 0 0zm-77.066 20.859c-2.942 1.253 1.563 2.385 0 0zm102.19 2.284c.7 2.992 4.89 1.724 0 0zm-125.94 6.672c-8.115 5.513-20.707 9.841-24.887 18.094 5.362 7.538 9.86 15.711 12.55 23.686 3.711 1.483 12.27 11.936 10.233 7.152-2.548-3.394 10.374 6.403 2.557 2.03-3.485 5.547 6.905 14.76 12.921 6.704 3.367-2.554 11.628-6.886 5.261.043-6.153 14.272 11.76 23.915 21.881 23.324-1.587 5.039 13.156 3.343 10.16-3.787 9.783 6.205 10.034-12.581 12.15-18.922 1.04-4.433 2.08-8.866 3.118-13.3-1.89 2.532-9.142.334-9.002 1.835-4.931-4.11-13.488 3.44-16.666-.151-6.938-1.54-9.062-7.517-9.739-12.985-8.094.567-3.698.62-1.576-4.514-5.869-.315-13.837-1.76-12.14-7.101-11.402-4.656-2.209-15.071-10.819-21.29-1.93-.648-3.984-.769-6.003-.82zm-44.965 12.864c-8.59-.995-7.514 5.968-13.225 2.946-10.15 5.745-20.136-2.751-30.925-1.387-29.137.253-51.071 29.092-55.872 56.42-7.326 13.756 5.339-.477 13.637-2.2-2.174-12.195 15.58-25.188 15.597-13.978-2.572 4.957.562 35.905 9.372 42.415 5.65 7.411 15.864 7.438 16.829-3.37 2.964-7.94 10.06-14.312 13.028-18.147-6.703 3.544-3.79-6.904-7.88-9.219 6.738-6.241-3.49-25.475.967-30.577 1.888.822 19.213-10.243 18.074 3.77 1.16 3.555-8.118 5.14-2.024 8.433-7.658 4.665 3.455 5.39-3.427 9.498 3.253 5.399 6.01 9.833 2.165 15.028 5.35 2.88-.846 4.956 2.464 9.859 1.778 3.928 6.245.778 1.383 5.41-1.361 8.392 12.419 11.331 9.277 18.591 8.517 3.138 17.255 14.93 21.647 1.175 4.39-6.642 8.989-13.158 13.44-19.766-3.415 1.673-6.978-2.014-10.4-3.306 3.183-7.442-7.567-10.669-4.388-18.695 2.026-5.576-2.942-14.986 1.397-15.442-3.634-2.89 2.346.649-.435-4.335 3.824-1.818-1.302-7.133 5.59-7.094-4.774-7.513 7.287-4.69 3.06-10.753-6.328-3.212 11.084-14.42-1.016-12.034-3.592-.464-14.71-3.287-18.334-3.242zm68.409 12.564c-5.594.816-1.062 2.671 0 0zm-106.58 10.76c-3.124 2.508 2.53 1.994 0 0zm-.18 2.165c-2.707.23 3.602 2.232 0 0zm116.32 1.983c-.612 2.06 1.536.488 0 0zm-33.123 9.258c-1.11 1.048.899.708 0 0zm-75.743 29.816c.207 1.666-.16.54 0 0zm1.322.06c.487 1.064-.19.145 0 0zm112.77 2.164c-3.791 1.324 3.067 2.71 0 0z",
    style: {
      fill: "url(#openldap_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#015a01"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.95 147.91c2.062 13.147-6.643 16.932-10.971 15.996",
    style: {
      stroke: "#015a01",
      strokeWidth: 1,
      fill: "#6c3"
    },
    transform: "translate(215.33 -72.118) scale(1.9236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45 144.66a14.908 15.413 0 0 1-28.87 1.41",
    style: {
      stroke: "#015a01",
      fill: "#6c3"
    },
    transform: "matrix(2.0679 0 0 1.9236 -85.252 -62.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4 122.14a13.756 14.188 0 0 1-9.596 26.558",
    style: {
      stroke: "#015a01",
      fill: "#6c3"
    },
    transform: "matrix(1.69038 0 0 1.9236 8.062 -62.905)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.42 204.03a13.577 11.915 0 1 1-20.903 3.651",
    style: {
      stroke: "#333",
      strokeWidth: 1.431,
      fill: "url(#openldap_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54 469.64c8.633 3.94 25.105 2 46.417-3.57M257.12 414.7c8.633 3.94 28.892 5.786 50.204.217M241.99 350.59c12.42 7.726 15.901 10.802 32.109 11.815",
    style: {
      stroke: "#015a01",
      strokeWidth: 1.7313,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45,
      stroke: "#015a01"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.76 154.03a10.902 13.628 0 1 1-21.804 0 10.902 13.628 0 1 1 21.804 0z",
    style: {
      opacity: 0.33,
      stroke: "#015a01",
      fill: "#060"
    },
    transform: "matrix(1.91312 -1.0905 1.23997 1.6825 -284.739 205.84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.467 124.52c-10.397 7.867 3.174 25.794 15.402 20.06 11.488-7.465-3.201-26.94-15.402-20.06z",
    style: {
      opacity: 0.33,
      stroke: "#015a01",
      fill: "#060"
    },
    transform: "translate(336.93 -40.977) scale(1.9236)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.28 150.64c-7.692.501-14.793 4.685-15.089 13.586a20.49 20.49 0 0 0 .48 3.306c-3.317-3.523-7.434-6.313-11.36-7.815-11.25-6.31-32.094-3.901-32.642 12.083 1.272 20.2 29.984 34.111 46.288 21.701 4.544-4.377 5.481-9.502 4.268-14.487 8.648 8.688 23.31 12.136 32.942 4.569 10.541-10.48-1.254-25.962-11.782-30.117-3.642-2.109-8.49-3.126-13.105-2.825z",
    style: {
      opacity: 0.5696,
      stroke: "#015a01",
      strokeWidth: 1.9236,
      fill: "#015a01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.96 116.34c1.938-.888 4.249.037 5.182 2.073 0 0 3.183 13.713 11.456 25.004 2.145 6.463-6.445 8.713-8.763 4.015 0 0-.968-10.617-11.456-25.004s.648-4.744 3.581-6.088z",
    style: {
      stroke: "#424242",
      strokeWidth: 1.9236,
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23 112.63a11.734 11.734 0 1 1-23.468 0 11.734 11.734 0 1 1 23.468 0z",
    style: {
      stroke: "#3c3c3c",
      strokeWidth: 2.843,
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.01 189.01c-3.48 7.067-14.963 8.53-25.649 3.27-10.687-5.262-16.529-15.256-13.05-22.323 3.48-7.067 12.924-3.34 25.649-3.269 11.911.067 16.529 15.255 13.05 22.322zM428.77 179.39c-2.932 6.147-12.61 7.42-21.616 2.844s-13.93-13.27-10.998-19.416c2.932-6.147 10.386-3.713 21.616-2.844 10.072.78 13.93 13.269 10.998 19.416z",
    style: {
      stroke: "#015a01",
      strokeWidth: 1.9236,
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.95 174.62a6.554 6.292 0 1 1-13.107 0 6.554 6.292 0 1 1 13.107 0z",
    style: {
      stroke: "url(#openldap_svg__d)",
      strokeWidth: 3.2702,
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.28 260.08c-66.519-.144-41.52 15.048-88.371 22.3-26.994 12.355 2.254 36.023-28.249 57.531-12.191 24.257 25.422 32.975 14.127 56.988 1.094 17.721 28.212 17.044 15.87 35.106.077 27.295 34.615 32.862 24.995 61.134 5.822 58.494 26.558 115.42 56.87 165.61 24.209 15.049 1.4 44.842 26.58 58.256-15.417 16.017-2.308 41.461-16.414 58.695-15.858 27.915-52.033 71.541-86.055 70.198-32.5 6.163-62.672-8.101-85.514 18.724-21.068 27.152 26.849 29.08 43.943 22.231 17.663-15.932 35.21-5.876 56.135-3.462 21.996 1.56 46.031-3.354 62.056-19.468 25.603.823 58.065-11.778 61.136-40.697 25.458-6.112 48.466-32.949 36.241-59.636 7.342-17.164 35.37-42.277 20.025-68.406 16.566-22.139-13.544-40.219-11.646-57.89 1.52-24.036-27.484-32.739-16.422-57.827-5.88-56.776-34.65-108.99-69.858-152.93-17.715-10.826-17.772-37.67-38.852-46.975-1.577-13.237-.082-35.222-15.13-46.08 12.85-21.035-11.481-49.556 20.581-57.405 9.32-6.825 11.765-6.15 17.952-15.995z",
    style: {
      opacity: 0.16,
      strokeOpacity: 0.45631,
      stroke: "#015a01",
      strokeWidth: 1.9236,
      fill: "#2f5a01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.39 291.24-33.123 5.23c17.189-1.058 41.41 10.702 52.138 2.144 2.808-7.652-14.418-4.55-19.015-7.374zm18.755 37.451c-2.226.221-5.16.953-5.951.18-15.9.467-38.753 1.689-50.255 5.951l31.379 7.996c9.785-5.765 36.092 1.65 26.45-11.301 2.09-2.727.603-3.047-1.623-2.826zm15.269 47.37c-23.53 1.418-46.945 4.234-70.513 5.17 18.484 2.734 36.866 6.798 55.605 3.547 8.85-2.878 26.726 3.882 14.908-8.717zm30.418 42.621c-17.609 2.141-22.028.732-40.577 1.082-12.172-.35-44.69.348-44.244 2.946 15.711 2.07 31.36 6.102 47.189 2.464 8.774-3.204 54.756 6.425 37.631-6.492zm27.472 33.664c-30.006 4.477-61.241 1.051-90.411 10.881l33.363 3.907c16.451-8.86 54.588-1.713 59.693-10.94zM497 602.56c-7.134-.107-15.756 1.445-21.4.36-22.649.075-44.368 7.02-66.305 11.783 15.165.922 30.594 7.281 45.446 1.623 15.954-6.58 41.892-5.303 52.539-10.82-2.28-2.21-5.999-2.882-10.279-2.946zm13.526 44.965c-14.177-.298-32.495 2.867-43.582.902l-33.002 5.23c31.72-.05 63.44.025 95.16 0-3.034-4.524-10.069-5.953-18.575-6.132zm-6.913 48.692c-4.496-.07-8.982.188-13.526 1.022l-32.522 8.175c21.543-3.55 43.01 2.847 64.562-1.202 11.962 2.216 20.66-8.78 3.907-6.793-7.5-.175-14.929-1.085-22.422-1.202zM465.2 757.773l-29.576 7.995c23.849 2.836 47.753 6.214 71.656 1.503 9.744-1.574 4.567-13.92-3.667-5.59-12.552 1.862-25.699-3.404-38.413-3.908zm-33.063 63.961-33.123 5.23c26.419-2.515 51.986 6.292 78.328 4.689 5.416-14.802-36.343-7.572-45.206-9.919zm-38.773 30.297c-10.945.795-21.774 3.134-32.642 4.81 19.66-1.443 39.974 13.754 57.409 7.573 8.563.63 33.329-2.739 11.842-4.929-12.15-2.623-23.995-7.708-36.61-7.454z",
    style: {
      opacity: 0.22,
      fill: "#816647"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.45 326.16c-10.886 1.967-8.4 22.052 3.066 22.302 8.465 2.325 15.632 3.845 26.342.932 11.164-8.74-4.137-14.974-12.453-12.714-16.156 1.402-6.886-8.034-16.955-10.52zm5.951 53.08c-15.564 5.843-1.743 25.357 11.602 21.821 10.833.873 16.443-4.823 22.422-7.514 13.366-13.213-9.2-14.904-16.952-6.011-12.514 4.096-8.06-5.899-17.072-8.296zm50.736 40.877c-10.278-.312-16.719 10.516-26.51 10.099-15.413-2.714-11.509 17.881 2.164 13.285 10.433 1.739 13.941-8.465 23.925-9.317 8.076-.63 9.6-13.53.421-14.067zm19.717 50.916c-7.237 2.817-15.739 11.599-24.045 7.213-17.483-12.77-11.249 18.608-.901 14.127 9.028 2.152 20.787-3.388 25.428-6.792 3.646.512 11.826-13.3-.482-14.547zm-4.629 17.373c-1.757 1.064 1.7-.61 0 0zm48.632 150.16c-16.235 5.22 1.896 25.317 13.465 25.067 10.318.826 21.684.346 28.734-8.176 9.25-23.358-30.97 7.123-37.196-14.127l-1.45-1.515-3.553-1.25zm7.334 67.027c-12.786 3.28-2.84 22.219 3.727 28.433 9.873 6.706 22.122 6.794 33.616 5.38 11.174-8.715-4.149-14.989-12.453-12.714-8 1.03-16.762-3.311-17.255-12.143-1.53-3.684-2.48-8.882-7.634-8.957zm12.864 32.822-.6-.3zm-60.354 65.344c-11.482 3.658-6.54 21.416-.12 28.373 4.485 5.22 7.873 12.227 12.203 15.208 5.716 3.355 9.67 8.453 16.776 5.416 9.556-6.93-8.199-14.998-5.835-13.892-5.885-2.69-9.886-12.655-15.028-18.034-3.525-5.64 2.14-16.518-7.995-17.072zm11.963 43.462c-2.054-2.264-.507-.136 0 0zm-91.313-6.312c-10.66 4.691-10.693 19.058-10.219 29.212-1.488 10.106 2.839 20.308 12.804 24.048 16.495 8.538 9.815-16.676 2.104-14.427-4.5-4.573.282-13.545-1.622-19.356-.478-6.55 10.803-17.505-3.067-19.477zm-75.623 3.246c-8.979 2.724-15.863 14.021-15.509 26.03-2.008 9.592 3.418 22.026 10.4 23.864 15.634 10.556 16.95-11.274 2.886-14.668-.48-9.208-.568-19.474 8.14-25.047 3.09-4.211-.8-10.666-5.916-10.179zm172.17 6.372c.434.02.033.146 0 0zm-92.816 5.59c.286-.058-.476.461 0 0z",
    style: {
      stroke: "#816647",
      strokeWidth: 2.5007,
      fill: "#ff9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43 108.33c2.104.342 3.508 2.397 3.148 4.608 0 0-4.995 13.162-4.414 27.147-1.818 6.562-10.206 3.646-9.514-1.547 0 0 5.11-9.356 4.414-27.147-.695-17.79 3.182-3.579 6.366-3.061z",
    style: {
      stroke: "#424242",
      strokeWidth: 1.9236,
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2 110.41a11.734 11.734 0 1 1-19.49-13.077 11.734 11.734 0 1 1 19.49 13.077z",
    style: {
      stroke: "#3c3c3c",
      strokeWidth: 2.843,
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.23 166.9a6.554 6.292 0 1 1-13.107 0 6.554 6.292 0 1 1 13.107 0z",
    style: {
      stroke: "url(#openldap_svg__e)",
      strokeWidth: 3.2702,
      fill: "#212121"
    }
  }));
};

export default SvgOpenldap;